export default __webpack_public_path__ + "static/media/190629_201216_PHOTO-2018-05-17-17-42-34.bbf7b41a.jpg";